import { ProductCardData } from '../../../../types';
import { ProductHat } from './components/ProductHat';
import { ProductButton } from './components/ProductButton';
import { ProductTitle } from '@wix/package-picker-components';
import { ProductPrice } from './components/ProductPrice';
import {
  useProductCards,
  UseProductCardsComponentsConfig,
  UseProductCardsProps,
} from '../../../../hooks/useProductCards';

const config: UseProductCardsComponentsConfig = {
  Hat: ProductHat,
  Title: ProductTitle,
  Cta: ProductButton,
  Price: ProductPrice,
};

export const useStudioProductCards = ({
  baseProducts,
  onSelectProduct,
  clickSource,
  appStore,
  minimizedDisplay = false,
}: UseProductCardsProps): ProductCardData[] => {
  return useProductCards({
    baseProducts,
    onSelectProduct,
    clickSource,
    appStore,
    minimizedDisplay,
    componentsConfig: config,
  });
};
